module.exports = {"540202001":"城南街道","540202002":"城北街道","540202200":"曲布雄乡","540202201":"曲美乡","540202202":"聂日雄乡","540202203":"甲措雄乡","540202204":"纳尔乡","540202205":"东嘎乡","540202206":"边雄乡","540202207":"江当乡","540202208":"年木乡","540202209":"联乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540202.json
// module id = 2687
// module chunks = 0